<template>
    <div class="px-0">
        <v-container class="px-0 py-5" style="max-width: 100% !important">
            <v-card class="px-0 py-3 size">
                <v-row class="px-5 pt-5">
                    <v-col cols="12" align="center" justify="center">    
                        <h3 class="blue_accent--text text-uppercase">{{ $t('create_tote.new') }}</h3>
                    </v-col>
                </v-row>
                <v-card-text class="px-0">
                    <v-form ref="form" lazy-validation @submit.prevent="save">
                        <v-row class="px-5 py-0 my-0" justify="center" align="center">
                            <v-col cols="6" class="py-0">
                                <v-text-field class="py-0" v-model="tote.name" :label="$t('create_tote.name')" :rules="rules_required"></v-text-field>
                            </v-col>
                        </v-row>
                        
                        <v-row class="px-5 py-0 my-0" justify="center" align="center">
                            <v-col cols="6" class="py-0">
                                <v-autocomplete class="py-0" v-model="tote.slot_id" :items="slots" :label="$t('create_tote.slot')" item-value="id" item-text="name" :rules="rules_required"></v-autocomplete> 
                            </v-col>
                        </v-row>
                    </v-form>
                    <v-row class="px-5 py-0" justify="center">
                        <v-col cols="6" justify="end" align="end">
                            <v-btn class="right px-3 mx-4" @click="cancel">
                                {{ $t('create_tote.cancel') }}
                            </v-btn>
                            <v-btn class="right white_highlight--text" color="secondary" @click="save" v-permission="'tote.create'">
                                {{ $t('create_tote.save') }}
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>    
        </v-container>   
        <v-snackbar v-model="snackbar.visible" :timeout="4000" :color="snackbar.color" style="text-align: center; color: var(--v-accent-base);">{{ snackbar.text }}</v-snackbar>
    </div>
</template>
<script>

import { HttpToteRepository } from "../infrastructure/tote_repository";
import { toteCreateUseCase } from "../application/use_cases/tote_create_use_case";
import { HttpSlotRepository } from "../../slots/infrastructure/slot_repository";
import { slotIndexUseCase } from "../../slots/application/use_cases/slot_index_use_case";

export default {
    computed: {
        rules_required(){return [v => !!v || this.$t('create_appointment.validations.required_field')]}, 
    },
    data(){
        return {
            snackbar: {
                visible: false,
                color: 'primary',
                text: ''
            },
            tote: {
                name: "",
                slot_id: null
            },
            slots: []
        }
    },
    mounted(){
        this.index();
        this.$store.state.module = "headers.create_tote";
    },
    methods: {
        async index(){
            const res = await slotIndexUseCase(HttpSlotRepository);

            this.slots = res;
        },
        async save(){
            try {
                const response = await toteCreateUseCase(this.tote, HttpToteRepository);
                this.snackbar = {
                    visible: true,
                    color: 'success2',
                    text: response.data.success.message
                }
                
                this.$router.go(-1);  
            } catch (e) {
                console.log(e)
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null? e : e.response.data.fault.message
                }
            }
        },
        cancel(){
            this.$router.go(-1);
        },
    },
    watch:{
    }
}
</script>

<style lang="css">
</style>